import { useMutation } from "react-query";
import { resendValidationEmail } from "src/authentication/data-access/gateway";
import { enqueueSnackbar } from "notistack";
import type { AxiosResponse } from "axios";

export function useResendValidationEmail() {
  return useMutation({
    mutationFn: resendValidationEmail,
    onSuccess: async (data: AxiosResponse) => {
      enqueueSnackbar(data?.data, {
        variant: "success",
      });
    },
  });
}
